/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Crop_HelpInputs */

const en_mobile_scan_crop_help = /** @type {(inputs: Mobile_Scan_Crop_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag the corners around the page you want to read. Keep neighboring pages outside the selection.`)
};

const es_mobile_scan_crop_help = /** @type {(inputs: Mobile_Scan_Crop_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra las esquinas alrededor de la página que quieres leer. Deja las páginas vecinas fuera de la selección.`)
};

/**
* | output |
* | --- |
* | "Drag the corners around the page you want to read. Keep neighboring pages outside the selection." |
*
* @param {Mobile_Scan_Crop_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_crop_help = /** @type {((inputs?: Mobile_Scan_Crop_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Crop_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_crop_help(inputs)
	return en_mobile_scan_crop_help(inputs)
});